import { Helmet } from "react-helmet-async"
import { TripSourcesTagList } from "../../../TripSources"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function OrganizationTripSourcesPage() {
	return (
		<>
			<Helmet>
				<title>Trip Sources Tags</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<TripSourcesTagList />
			</ForbidUnlessAuthorized>
		</>
	)
}
